<template>
  <div v-if="filteredErrors.length">

    <Alert
      type="error"
      class="uk-text-danger uk-text-bold blink-1"
      style="font-size: 13px;"
    >
      <div
        v-for="error in filteredErrors"
        :key="error.id"
      >
        {{ error.msg }}
      </div>
    </Alert>
  </div>
</template>
<script>
export default {
  props: {
    sectionErrors: {
      type: Array,
      default: () => {}
    },
    type: {
      type: String,
      default: 'journey'
    }
  },
  data () {
    return {
      fields: ['arrival_at', 'departure_at', 'adults', 'childs', 'age_of_childs'],
      fields2: ['arrival_at', 'departure_at', 'adults', 'childs', 'age_of_childs', 'unit_id']
    }
  },
  computed: {
    filteredErrors () {
      const errors = this.sectionErrors.filter(error => {
        if (this.type === 'unit') {
          return error.field === 'unit_id'
        } else {
          if (this.type === 'journey') {
            return this.fields.includes(error.field)
          } else {
            return !this.fields2.includes(error.field)
          }
        }
      })
      return errors
    }
  }
}
</script>
